module.exports = __webpack_public_path__ + "static/media/cw1.95dcce71.png";